import styled from "styled-components";

// tslint:disable-next-line
export const ContainerWithWhiteBorder = styled.div`
  border: 1px solid #fff;
  border-radius: 2px;
`;
